import request from '@/utils/request'


// 流动科技馆公告
export function getPortablePipeProfilesInfo(data) {
    return request({
        url: '/api/portablepipe/getPortablePipeProfilesInfo',
        method: 'GET',
        data
    });
}

// 流动科技馆活动报道列表
export function getNewsList(data) {
    return request({
        url: '/api/portablepipe/getPortablePipeStoriesList',
        method: 'GET',
        data
    });
}

// 流动科技馆活动报道详情
export function getNewsDetail(id) {
    return request({
        url: `/api/portablepipe/getPortablePipeStoriesEntityInfo/${id}`,
        method: 'GET',
    });
}

// 流动科技馆获取模板
export function getTemplateFile() {
    return request({
        url: '/api/scimuseum/scimuseumapply/getTemplateFile',
        method: 'GET',
        'Content-Type': 'application/json'
    });
}

// 流动科技馆上传文件
export function upload(data) {
    return request({
        url: '/api/attachment/fileUploadReturnUrl',
        method: 'POST',
        'Content-Type': 'multipart/form-data',
        data
    });
}

// 流动科技馆提交申请
export function submitApply(data) {
    return request({
        url: '/api/scimuseum/scimuseumapply/submitApply',
        method: 'POST',
        data
    });
}


// WEBPACK FOOTER //
// ./src/api/museum/index.js